/* tslint:disable */
/* eslint-disable */
export enum ImportedEventsLineResultErrorType {
    Error = 0,
    Warning = 1
  }